var _defs, _rect, _rect2, _rect3, _text, _text2, _rect4, _text3, _rect5, _polygon, _polygon2, _rect6, _text4, _rect7, _circle, _circle2, _circle3, _line, _circle4, _rect8, _text5, _rect9, _polygon3, _polygon4, _rect0, _text6, _rect1, _polygon5, _polygon6, _rect10, _text7, _rect11, _polygon7, _polygon8, _rect12, _text8, _rect13, _circle5, _circle6, _circle7, _line2, _circle8, _rect14, _text9, _rect15, _polygon9, _polygon0, _rect16, _text0, _rect17, _polygon1, _polygon10, _rect18, _text1, _rect19, _circle9, _circle0, _circle1, _line3, _circle10, _rect20, _text10, _rect21, _polygon11, _polygon12, _rect22, _text11, _rect23, _polygon13, _polygon14, _rect24, _text12, _rect25, _circle11, _circle12, _circle13, _line4, _circle14, _rect26, _text13, _rect27, _line5, _text14, _text15, _text16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 600",
    width: 440,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mn-bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#050d1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#071120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#030a15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mn-cell",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0d1e33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#091729"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mn-safe",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#102a15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a1e0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mn-bomb",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2a0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a0707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mn-gem",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a8ffcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#72F238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3ab810"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mn-title",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffc84c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffdf80"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "mn-dots",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 0.8,
    fill: "rgba(255,255,255,0.04)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "url(#mn-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "url(#mn-dots)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 440,
    height: 3,
    fill: "url(#mn-title)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 56,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 32,
    fontWeight: 900,
    fill: "url(#mn-title)",
    letterSpacing: 6
  }, "MINE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 78,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 11,
    fontWeight: 500,
    fill: "rgba(255,255,255,0.35)",
    letterSpacing: 3
  }, "AVOID THE BOMBS")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 102,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-cell)",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 142,
    textAnchor: "middle",
    fontSize: 22,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.1)"
  }, "?")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 102,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-safe)",
    stroke: "rgba(114,242,56,0.22)",
    strokeWidth: 1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "150,114 163,127 150,150 137,127",
    fill: "url(#mn-gem)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "150,114 163,127 150,127",
    fill: "rgba(255,255,255,0.3)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 102,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-cell)",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 142,
    textAnchor: "middle",
    fontSize: 22,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.1)"
  }, "?")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 102,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-bomb)",
    stroke: "rgba(239,68,68,0.25)",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 133,
    r: 18,
    fill: "#12080800",
    stroke: "#ef4444",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 133,
    r: 10,
    fill: "#1a0a0a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 129,
    r: 4,
    fill: "rgba(255,255,255,0.15)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 290,
    y1: 115,
    x2: 290,
    y2: 108,
    stroke: "#ef4444",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 107,
    r: 3.5,
    fill: "#ffc84c"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 102,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-cell)",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 142,
    textAnchor: "middle",
    fontSize: 22,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.1)"
  }, "?")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 172,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-safe)",
    stroke: "rgba(114,242,56,0.22)",
    strokeWidth: 1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,184 93,197 80,220 67,197",
    fill: "url(#mn-gem)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,184 93,197 80,197",
    fill: "rgba(255,255,255,0.3)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 172,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-cell)",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 212,
    textAnchor: "middle",
    fontSize: 22,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.1)"
  }, "?")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 172,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-safe)",
    stroke: "rgba(114,242,56,0.22)",
    strokeWidth: 1
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "220,184 233,197 220,220 207,197",
    fill: "url(#mn-gem)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.7;1;0.7",
    dur: "1.8s",
    repeatCount: "indefinite"
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "220,184 233,197 220,197",
    fill: "rgba(255,255,255,0.3)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 172,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-cell)",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 212,
    textAnchor: "middle",
    fontSize: 22,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.1)"
  }, "?")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 172,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-safe)",
    stroke: "rgba(114,242,56,0.22)",
    strokeWidth: 1
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "360,184 373,197 360,220 347,197",
    fill: "url(#mn-gem)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "360,184 373,197 360,197",
    fill: "rgba(255,255,255,0.3)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 242,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-cell)",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 282,
    textAnchor: "middle",
    fontSize: 22,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.1)"
  }, "?")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 242,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-bomb)",
    stroke: "rgba(239,68,68,0.25)",
    strokeWidth: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 273,
    r: 18,
    fill: "transparent",
    stroke: "#ef4444",
    strokeWidth: 1.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 273,
    r: 10,
    fill: "#1a0a0a"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 269,
    r: 4,
    fill: "rgba(255,255,255,0.15)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 255,
    x2: 150,
    y2: 248,
    stroke: "#ef4444",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 247,
    r: 3.5,
    fill: "#ffc84c"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "0.6s",
    begin: "0.2s",
    repeatCount: "indefinite"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 242,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-cell)",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 282,
    textAnchor: "middle",
    fontSize: 22,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.1)"
  }, "?")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 242,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-safe)",
    stroke: "rgba(114,242,56,0.22)",
    strokeWidth: 1
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "290,254 303,267 290,290 277,267",
    fill: "url(#mn-gem)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;1;0.6",
    dur: "2.2s",
    repeatCount: "indefinite"
  }))), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "290,254 303,267 290,267",
    fill: "rgba(255,255,255,0.3)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 242,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-cell)",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 282,
    textAnchor: "middle",
    fontSize: 22,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.1)"
  }, "?")), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 312,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-safe)",
    stroke: "rgba(114,242,56,0.22)",
    strokeWidth: 1
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,324 93,337 80,360 67,337",
    fill: "url(#mn-gem)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,324 93,337 80,337",
    fill: "rgba(255,255,255,0.3)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 312,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-cell)",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 352,
    textAnchor: "middle",
    fontSize: 22,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.1)"
  }, "?")), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 312,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-bomb)",
    stroke: "rgba(239,68,68,0.25)",
    strokeWidth: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 343,
    r: 18,
    fill: "transparent",
    stroke: "#ef4444",
    strokeWidth: 1.5
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 343,
    r: 10,
    fill: "#1a0a0a"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 339,
    r: 4,
    fill: "rgba(255,255,255,0.15)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 325,
    x2: 220,
    y2: 318,
    stroke: "#ef4444",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 317,
    r: 3.5,
    fill: "#ffc84c"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "0.6s",
    begin: "0.4s",
    repeatCount: "indefinite"
  }))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 312,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-cell)",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 352,
    textAnchor: "middle",
    fontSize: 22,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.1)"
  }, "?")), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 312,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-safe)",
    stroke: "rgba(114,242,56,0.22)",
    strokeWidth: 1
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "360,324 373,337 360,360 347,337",
    fill: "url(#mn-gem)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;1;0.8",
    dur: "1.6s",
    repeatCount: "indefinite"
  }))), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "360,324 373,337 360,337",
    fill: "rgba(255,255,255,0.3)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 382,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-cell)",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 422,
    textAnchor: "middle",
    fontSize: 22,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.1)"
  }, "?")), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 382,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-safe)",
    stroke: "rgba(114,242,56,0.22)",
    strokeWidth: 1
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "150,394 163,407 150,430 137,407",
    fill: "url(#mn-gem)"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "150,394 163,407 150,407",
    fill: "rgba(255,255,255,0.3)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 382,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-cell)",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 422,
    textAnchor: "middle",
    fontSize: 22,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.1)"
  }, "?")), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 382,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-bomb)",
    stroke: "rgba(239,68,68,0.25)",
    strokeWidth: 1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 413,
    r: 18,
    fill: "transparent",
    stroke: "#ef4444",
    strokeWidth: 1.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 413,
    r: 10,
    fill: "#1a0a0a"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 409,
    r: 4,
    fill: "rgba(255,255,255,0.15)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 290,
    y1: 395,
    x2: 290,
    y2: 388,
    stroke: "#ef4444",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 387,
    r: 3.5,
    fill: "#ffc84c"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "0.6s",
    begin: "0.1s",
    repeatCount: "indefinite"
  }))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 382,
    width: 62,
    height: 62,
    rx: 8,
    fill: "url(#mn-cell)",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 422,
    textAnchor: "middle",
    fontSize: 22,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.1)"
  }, "?")), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 475,
    width: 440,
    height: 125,
    fill: "rgba(0,0,0,0.45)"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 475,
    x2: 440,
    y2: 475,
    stroke: "rgba(255,200,76,0.15)",
    strokeWidth: 1
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 518,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 14,
    fontWeight: 500,
    fill: "rgba(255,255,255,0.4)",
    letterSpacing: 1
  }, "MINES ACTIVE")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 555,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 40,
    fontWeight: 900,
    fill: "#ffc84c"
  }, "4")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 578,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 11,
    fontWeight: 500,
    fill: "rgba(255,255,255,0.25)",
    letterSpacing: 2
  }, "NEXTGEN ORIGINALS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMine);
export default __webpack_public_path__ + "static/media/mine.53c0964cf28b21dbb3c08615fa9ba31f.svg";
export { ForwardRef as ReactComponent };